import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


const themeColor=[{
  id:"colors",
  maincolor: "#0c39a1",
  secondarycolor: "#ffdd48",
  textcolor:"white",
  cardcolor:"white",
  backgroundcolor:"white",
  namecolor:"black",
  descriptioncolor:"rgb(113, 128, 150)",
  headercolor:"white",
  footercolor:"black",
  footerlinkcolor:"white"
  
}]

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
 {themeColor.map((theme) => (
    <App    
    key={theme.id}
    maincolor={theme.maincolor}
    secondarycolor={theme.secondarycolor}
    cardcolor={theme.cardcolor}
    textcolor={theme.textcolor}
    backgroundcolor={theme.backgroundcolor}
    namecolor={theme.namecolor}
    descriptioncolor={theme.descriptioncolor}
    headercolor={theme.headercolor} 
    footercolor={theme.footercolor} 
    footerlinkcolor={theme.footerlinkcolor}
    />))}
 
  </React.StrictMode>
);
reportWebVitals();
